export { createSynapse } from './createSynapse'
export type { Synapse, SynapseModule, SyncSynapseModule, SyncSynapseOptions } from './synapse.types'
export type { DependencyInput, ExtractPromiseType, ExtractStorageType, StorageCreatorFunction, SynapseDependency } from './types'
